import React from 'react';
import { compare as compareObject } from '../../utils/functions';
import styles from './Home.module.css';
import Logo from '../../assets/logo2.png';

export function BotsPanel(props) {
  return (
    <div>
      {Object.values(props.bots).sort((a, b) => compareObject(a, b, 'name')).map((bot) => (
        <div
          key={bot.id}
          className={styles.BotCard}
          role="button"
          tabIndex="0"
          onKeyPress={() => props.handleClickBot(bot.id)}
          onClick={() => props.handleClickBot(bot.id)}
        >
          <div>
            <div>
              <img src={Logo} alt="Logo" />
            </div>
            <div className="title" title={bot.name}>
              <h6>{bot.name}</h6>
            </div>
            <div title={bot.description}>
              {bot.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BotsPanel;
